// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1784537011791
      var cssReload = require("/usr/src/app/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  